import {
  Chip as NextUIChip,
  ChipProps as NextUIChipProps,
} from "@heroui/react";

interface ChipProps extends NextUIChipProps {}

export const Chip = ({ children, ...props }: ChipProps) => {
  return <NextUIChip {...props}>{children}</NextUIChip>;
};
